import React, { useRef, useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const ZCanvasComponent = ({zobject}) => { 
    let {width, height} = zobject;
    let ref = useRef(undefined);
    let ctxt = useRef(undefined);

    useEffect(() => {
        ctxt.current = ref.current.getContext('2d');
        zobject.effect.ctxt = ctxt.current;

        return () => zobject.effect.ctxt = undefined;
    }, []);
    
    useEffect(() => {
        if (ctxt.current) {
            ctxt.current.scale(window.devicePixelRatio, window.devicePixelRatio);
        }
    }, [width, height]);



    return (<canvas
              height={height*window.devicePixelRatio}
              width={width*window.devicePixelRatio}
              style={{width, height}}
              ref={ref} ></canvas>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZCanvasComponent);
